import { Tabs, TabsProps } from 'components/tabs/Tabs'
import { FC, useEffect } from 'react'
import { useRouterQueryState } from 'utils/hooks'

export interface RouterTabsProps extends Omit<TabsProps, 'onTabSelected' | 'selectedTabKey'> {
  defaultTabKey?: string
  onTabSelected?: TabsProps['onTabSelected']
}

export const RouterTabs: FC<RouterTabsProps> = (props) => {
  const [state, setState, isLoaded] = useRouterQueryState<{ tab: string }>()

  useEffect(() => {
    if (!state.tab && props.defaultTabKey && isLoaded) {
      setState({ tab: props.defaultTabKey })
    }
  }, [props.defaultTabKey, setState, state.tab, isLoaded])

  return (
    <Tabs
      {...props}
      selectedTabKey={state?.tab ?? props.defaultTabKey ?? props.tabs[0]?.key ?? ''}
      onTabSelected={(tab) => {
        props.onTabSelected?.(tab)
        setState({
          tab,
        })
      }}
      swipeable
    />
  )
}
